exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-dashboard-widgets-ranking-___styles__container___213kw {\n  height: 100%;\n  display: flex;\n  padding-top: 18px;\n}\n\n.src-components-dashboard-widgets-ranking-___styles__block___8U5Oi {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  transition: height 1s;\n}\n\n.src-components-dashboard-widgets-ranking-___styles__legend___2Xopp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  width: 100%;\n  position: relative;\n}\n\n.src-components-dashboard-widgets-ranking-___styles__label___2J-3c {\n  min-width: calc(80% - 30px);\n  max-width: calc(80% - 30px);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.src-components-dashboard-widgets-ranking-___styles__value___37e1y {\n  min-width: 30px;\n  max-width: 30px;\n  text-align: right;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-dashboard-widgets-ranking-___styles__container___213kw",
	"block": "src-components-dashboard-widgets-ranking-___styles__block___8U5Oi",
	"legend": "src-components-dashboard-widgets-ranking-___styles__legend___2Xopp",
	"label": "src-components-dashboard-widgets-ranking-___styles__label___2J-3c",
	"value": "src-components-dashboard-widgets-ranking-___styles__value___37e1y"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/ranking/styles.scss
// module id = 2234
// module chunks = 0